/**
 * One-shot hand-off telling the page someone lands on to show "discount applied"
 * after they sign up through the Book Now offer sheet.
 *
 * sessionStorage rather than router state or Redux: the sheet finishes by letting
 * the panel replay the original action, and the Apple and Google paths bounce
 * through an external provider and a full page load, which router state would not
 * survive. It is read once and cleared, so a later visit does not re-announce it.
 */
const KEY = "signupDiscountApplied";

/** Called by the offer sheet once an account has been created. */
export const flagSignupDiscountApplied = (): void => {
    try {
        sessionStorage.setItem(KEY, "true");
    } catch {
        // Private browsing or blocked storage: the banner is a nicety, not a
        // requirement, so failing to set it must not break the sign-up.
    }
};

/** True once, for the landing page to show the banner; clears itself. */
export const consumeSignupDiscountApplied = (): boolean => {
    try {
        const flagged = sessionStorage.getItem(KEY) === "true";
        if (flagged) sessionStorage.removeItem(KEY);
        return flagged;
    } catch {
        return false;
    }
};
